import React from 'react'
import { renderRoutes } from 'react-router-config'
import PropTypes from 'prop-types'

import Header from 'Components/Blocks/Header'

import { Container, Content, PageContent } from './styles'

function App({ route }) {
  return (
    <Container>
      <Header />
      <Content>
        <PageContent>{renderRoutes(route.routes)}</PageContent>
      </Content>
    </Container>
  )
}

App.propTypes = {
  route: PropTypes.object.isRequired,
}

export default App
